export const booleanStringYNOptions = [
  { value: '', label: '[Default Select All]' },
  { value: 'true', label: 'Y' },
  { value: 'false', label: 'N' },
];
